import React, { useState, useRef } from "react";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { Formik } from "formik";
import Modal from "react-bootstrap/Modal";
import SignatureCanvas from "react-signature-canvas";
import * as Yup from "yup";
import { Button, Spinner } from "react-bootstrap";
import styles from "./styles.module.css";
import InputText from "components/common/InputText";
import { uploadSignature, getUserSignature } from "services/deficiency";
import { toast } from "react-toastify";
import ImageTag from "components/common/ImageTag";
function Signature({
  title,
  id,
  image = "",
  type,
  heading,
  setChangesState,
  changesState,
}) {
  const [showSign, setShowSign] = useState(false);
  let signatureSchema;
  const handleSignShow = () => setShowSign(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [signLoading, setSignLoading] = useState(false);

  let [data, setData] = useState("");
  let sigCanvas = useRef<any>({});
  const handleSignModalClose = () => {
    sigCanvas?.current?.clear();
    setShowSign(false);
    setData("");
  };
  const handleSubmitForm = (values: any) => {
    setBtnLoading(true);
    const signature = data;
    const signType = type;
    uploadSignature({
      id,
      signature,
      witness_name: values.witness_name,
      type: signType,
    })
      .then((response) => {
        toast.success(response.message);
        setBtnLoading(false);
        setChangesState(!changesState);
        handleSignModalClose();
      })
      .catch((error) => {
        setBtnLoading(false);
        toast.error(error?.response?.message);
      });
  };
  function setSignatureOnChange(setFieldValue) {
    const sign = sigCanvas?.current?.toDataURL("image/png");
    setData(sign);
    setFieldValue("sign", sign);
  }
  if (type == "witness") {
    signatureSchema = Yup.object().shape({
      sign: Yup.string().required("Sign is required"),
      witness_name: Yup.string()
        .required("Witness Name is require")
        .min(1)
        .max(255)
        .label("Witness Name"),
    });
  } else {
    signatureSchema = Yup.object().shape({
      sign: Yup.string().required("Sign is required"),
    });
  }

  const getSignature = () => {
    setSignLoading(true);
    getUserSignature(id)
      .then((response) => {
        if (response.status) {
          setChangesState(!changesState);
          setSignLoading(false);
        } else {
          handleSignShow();
          setChangesState(!changesState);
          setSignLoading(false);
        }
      })
      .catch((error) => {
        setSignLoading(false);
        toast.error(error?.response?.message);
      });
  };

  const initialObject = { sign: "", witness_name: "" };

  return (
    <div>
      <Card className="p-0 border-0 text-center">
        <Card.Body className="p-0">
          {image || type == "witness" ? (
            <label className="w-100" onClick={handleSignShow}>
              <Form.Group className="profile-browse-box text-center">
                {image ? (
                  <ImageTag
                    src={image}
                    alt="witness signature"
                    className="w-100 max-height-100"
                  />
                ) : (
                  <div>No Signature</div>
                )}
              </Form.Group>
            </label>
          ) : signLoading ? (
            <label className="w-100" onClick={getSignature}>
              <Form.Group className="profile-browse-box text-center">
                <Spinner animation="grow" size="sm" variant="warning" />
                <Spinner animation="grow" size="sm" variant="danger" />
                <Spinner animation="grow" size="sm" variant="warning" />
              </Form.Group>
            </label>
          ) : (
            <label className="w-100" onClick={getSignature}>
              <Form.Group className="profile-browse-box text-center">
                {image ? (
                  <ImageTag
                    src={image}
                    alt="witness signature"
                    className="w-100 max-height-100"
                  />
                ) : (
                  <div>No Signature</div>
                )}
              </Form.Group>
            </label>
          )}

          <Card.Text className="fs-15 text-default">{title}</Card.Text>
        </Card.Body>
      </Card>
      {/*Signature Modal*/}
      <Modal
        show={showSign}
        onHide={handleSignModalClose}
        centered
        dialogClassName="modal-400w"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-25 fw-bold">{heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={signatureSchema}
            initialValues={initialObject}
            onSubmit={handleSubmitForm}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              setFieldValue,
            }) => (
              <>
                <div className={styles.sigContainer}>
                  {type == "witness" && (
                    <InputText
                      controlId="witness_name"
                      label="Name of Witness"
                      placeholder="Name and title of Witness"
                      touched={touched.witness_name}
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                      errorsField={errors.witness_name}
                      value={values.witness_name}
                    />
                  )}
                  <SignatureCanvas
                    ref={sigCanvas}
                    penColor="black"
                    canvasProps={{ className: styles.sigPad }}
                    onEnd={() => {
                      setSignatureOnChange(setFieldValue);
                    }}
                  />

                  {errors.sign && (
                    <p className="text-danger">Sign is required</p>
                  )}
                  <p>
                    Sign here using MOUSE or TOUCH screen if using a tablet.
                  </p>
                </div>
                <div className="d-flex justify-content-end mt-4">
                  <button
                    type="reset"
                    onClick={handleSignModalClose}
                    className="me-2 fw-semibold my-1 text-black btn btn-outline-secondary"
                  >
                    Close
                  </button>
                  {btnLoading ? (
                    <button
                      className="fw-semibold text-black btn btn-primary my-1"
                      type="submit"
                    >
                      <Spinner size="sm" />
                    </button>
                  ) : (
                    <Button
                      type="submit"
                      variant="primary"
                      onClick={(e) => {
                        handleSubmit();
                      }}
                      className="btn btn-primary my-1 fw-semibold"
                    >
                      Submit
                    </Button>
                  )}
                </div>
              </>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Signature;
